
export enum MarkerType {
    Standard = 0,
    HighAngle = 1,
    HighAccuracy = 2,
}

export const MarkerTypeDescription: string[] = [
    "Standard Marker",
    "High-Angle Marker",
    "High-Accuracy Marker",
];
